@if (!embedded()) {
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-back-button
          mode="md"
          defaultHref="settings"
        ></ion-back-button>
      </ion-buttons>
      <ion-title
        role="heading"
        aria-level="1"
        mode="md"
      >
        {{ 'page.settings.notifications' | translate }}
      </ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding">
    <div class="app__content notifications">
      <div class="app__description">
        <p>{{ 'page.settings.notifications.desc' | translate }}</p>
      </div>
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>
  </ion-content>
} @else {
  <ng-container *ngTemplateOutlet="content"></ng-container>
}
<ng-template #content>
  <ng-container [formGroup]="permissionsForm">
    @if (!isPwa) {
      <app-settings-control
        [type]="'push'"
        [control]="pushControl"
      ></app-settings-control>
    }
    <app-settings-control
      [type]="'email'"
      [control]="emailControl"
      [descriptionInput]="emailDescription()"
    ></app-settings-control>
  </ng-container>
</ng-template>
